export enum OfferType {
  TENDER = 'tender',
  EXTRA = 'extra',
  MAXIMAP = 'maximap',
  SUBSCRIPTION = 'subscription'
}
